// @flow
export const InventoryCountProcessPageLocale = {
  header: [
    "Inventory Counting Process & Technologies",
    "Envanter Sayım Süreç ve Teknolojileri"
  ],
  header_secondary: [
    "We work to meet our partner firm's expectations in all inventory solutions with our allways-up-to-date technology, our local stock counting application compatible with all operation systems, our online dashboard that lets you manage all processes before, during and after the stock counting processes, and our dynamic reporting system.",
    "Sürekli güncel teknolojilerimiz; tüm işletim sistemlerinde sorunsuz çalışan lokal sayım uygulamamız; sayım öncesi, sırası ve sonrasındaki tüm süreçleri online arayüz ile yönetebileceğiniz sistemimiz ve dinamik raporlama programımız ile iş ortaklarımızın memnuniyetini sağlamak için buradayız."
  ],
  content: {
    main_content: [
      "Our mission is to not only provide stock-counting services, but while doing that to develop solutions to the problems both for our stock-taking processes and our customer's operations; and to produce innovations that will optimize the processes for both sides in all aspects of inventory.",
      "Sayım hizmeti vermenin yanısıra, bunu yaparken tüm envanter süreçlerinde hem sayım operasyonu hem de çalıştığımız firmanın operasyonel süreçleri doğrultusunda karşımıza çıkan problemlere çözümler geliştirmek; yalnız sayım yapmak değil bunun yanında bu alandaki tüm süreçleri optimize edecek girişimlerde bulunmak asli görevimizdir."
    ],
    services: {
      content: [
        "Services:",
        "Hizmetlerimiz:"
      ],
      items: {
        one: [
          "Inventory / Stock taking",
          "Envanter sayımı"
        ],
        two: [
          "Fixture stock taking",
          "Demirbaş sayımı"
        ],
        three: [
          "Rental stock-taking handheld devices and stock-taking management software",
          "Sayım cihazları ve sayım takip yazılımı kiralama"
        ]
      }

    },
    contact: [
      "You can contact iletisim@envanterium.com to get more information about our inventory solutions.",
      "Sayım hizmetlerimizle ilgili daha fazla bilgi almak için iletisim@envanterium.com adresi ile iletişime geçebilirsiniz."
    ]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicPages/InventoryCountProcessPage.locale.js